export default __webpack_public_path__ + "b14fe6031ba973726c0b8ec1b041e307.png";